import { ModalComponent, Text } from '@SBGSports/catapult-core';
import { ActivityStatus } from './activity-status-util';
import { useTranslations } from 'i18n';
import { ActivityStatusRow } from './activity-status-row';

const NoActivitiesProcessed: React.FC = () => {
    const { __ } = useTranslations();
    return (
        <>
            <div className="h-px w-full bg-system-outline-variant absolute top-0" />
            <Text variant="body-large" className="text-center">
                {__('data_processing.no_activities_processed')}
            </Text>
        </>
    );
};

interface ProcessingStatusModalProps {
    activityStatuses: ActivityStatus[];
    showProcessingModal: boolean;
    onClose: () => void;
}

const ProcessingStatusModal = (props: ProcessingStatusModalProps) => {
    const { __ } = useTranslations();
    const { activityStatuses, showProcessingModal, onClose } = props;

    const anyActivities = activityStatuses?.length > 0;
    const title = __('data_processing.activity_processing_history');
    const subTitle = __('data_processing.activity_processing_explanation');
    return (
        <ModalComponent
            id="processing-status-modal"
            openModal={showProcessingModal}
            dismissible
            size="3xl"
            rounding="2xl"
            handleClose={onClose}
            handleCancel={onClose}
            handleConfirm={onClose}
            showFooter={false}
            position="center"
            bodyClassName={`relative flex flex-col items-center mb-5 ${
                anyActivities ? 'justify-start' : 'justify-center'
            }`}
            title={title}
            subTitle={subTitle}
        >
            {anyActivities ? (
                activityStatuses
                    .sort((a, b) => new Date(b.modifiedDate).getTime() - new Date(a.modifiedDate).getTime())
                    .map((a) => <ActivityStatusRow key={a.activityId} activityStatus={a} />)
            ) : (
                <NoActivitiesProcessed />
            )}
        </ModalComponent>
    );
};

export default ProcessingStatusModal;
